"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.S2_APM_TYPE_IDS = exports.APM_TYPES = void 0;
/* eslint-disable import/prefer-default-export */

var S2_APM_TYPE_IDS = exports.S2_APM_TYPE_IDS = {
  Cleveron301: 12,
  Cleveron302: 5,
  Cleveron308: 26,
  Cleveron311: 21,
  Cleveron351: 19,
  Cleveron352: 22,
  Cleveron354: 24,
  Cleveron355: 25,
  Cleveron401Gen1: 11,
  Cleveron401Gen2: 18,
  Cleveron402Gen1: 14,
  Cleveron402Gen2: 15,
  Cleveron403: 17,
  Cleveron405: 20,
  Cleveron501: 16,
  Cleveron503: 23
};
var APM_TYPES = exports.APM_TYPES = [{
  gen: 1,
  s2ApmTypeId: S2_APM_TYPE_IDS.Cleveron301,
  series: 301
}, {
  gen: 2,
  s2ApmTypeId: S2_APM_TYPE_IDS.Cleveron301,
  series: 301
}, {
  gen: 1,
  s2ApmTypeId: S2_APM_TYPE_IDS.Cleveron302,
  series: 302
}, {
  gen: 1,
  s2ApmTypeId: S2_APM_TYPE_IDS.Cleveron308,
  series: 308
}, {
  gen: 1,
  s2ApmTypeId: S2_APM_TYPE_IDS.Cleveron311,
  series: 311
}, {
  gen: 1,
  s2ApmTypeId: S2_APM_TYPE_IDS.Cleveron311,
  series: 312
}, {
  gen: 1,
  s2ApmTypeId: S2_APM_TYPE_IDS.Cleveron311,
  series: 313
}, {
  gen: 1,
  s2ApmTypeId: S2_APM_TYPE_IDS.Cleveron301,
  series: 314
}, {
  gen: 1,
  s2ApmTypeId: S2_APM_TYPE_IDS.Cleveron351,
  series: 351
}, {
  gen: 2,
  s2ApmTypeId: S2_APM_TYPE_IDS.Cleveron351,
  series: 351
}, {
  gen: 1,
  s2ApmTypeId: S2_APM_TYPE_IDS.Cleveron352,
  series: 352
}, {
  gen: 1,
  s2ApmTypeId: S2_APM_TYPE_IDS.Cleveron354,
  series: 354
}, {
  gen: 1,
  s2ApmTypeId: S2_APM_TYPE_IDS.Cleveron355,
  series: 355
}, {
  gen: 1,
  s2ApmTypeId: S2_APM_TYPE_IDS.Cleveron401Gen1,
  series: 401
}, {
  gen: 2,
  s2ApmTypeId: S2_APM_TYPE_IDS.Cleveron401Gen2,
  series: 401
}, {
  gen: 1,
  s2ApmTypeId: S2_APM_TYPE_IDS.Cleveron402Gen1,
  series: 402
}, {
  gen: 2,
  s2ApmTypeId: S2_APM_TYPE_IDS.Cleveron402Gen2,
  series: 402
}, {
  gen: 3,
  s2ApmTypeId: S2_APM_TYPE_IDS.Cleveron402Gen2,
  series: 402
}, {
  gen: 1,
  s2ApmTypeId: S2_APM_TYPE_IDS.Cleveron403,
  series: 403
}, {
  gen: 1,
  s2ApmTypeId: S2_APM_TYPE_IDS.Cleveron405,
  series: 405
}, {
  gen: 1,
  s2ApmTypeId: S2_APM_TYPE_IDS.Cleveron501,
  series: 501
}, {
  gen: 1,
  s2ApmTypeId: S2_APM_TYPE_IDS.Cleveron503,
  series: 503
}];